import styled from 'styled-components';

export const Heading = styled.p`
text-align: center;
color: white;
display: block;
`;

export const Content = styled.div`
overflowY: scroll;
height: 1000px;
`;

export const Button = styled.div`
position: fixed;
width: 100%;
left: 90%;
bottom: 40px;
height: 25px;
font-size: 1.5rem;
z-index: 1;
cursor: pointer;
color: black;
`
